@if (!person) {
  <h2 mat-dialog-title>Add person</h2>
} @else {
  <h2 mat-dialog-title>Edit person</h2>
}

<mat-dialog-content>
  <form id="person-form" (submit)="submit($event)">
    <p>
      <mat-form-field appearance="outline">
        <mat-label>ORCID</mat-label>
        <mat-hint>The 16-digit ORCID in the format 0000-0000-0000-0000</mat-hint>
        <input matInput [formField]="personForm.orcid" />
      </mat-form-field>
    </p>

    <p style="display: flex; justify-content: end">
      <button
        matButton="tonal"
        type="button"
        [disabled]="pending() || personForm.orcid().invalid() || !personForm.orcid().value()"
        (click)="$event.preventDefault(); lookup()"
      >
        Lookup in ORCID registry
      </button>
    </p>

    <mat-divider />

    <p>
      <mat-form-field appearance="outline">
        <mat-label>First name</mat-label>
        <input matInput [formField]="personForm.firstName" autocomplete="given-name" />
        @if (pending()) {
          <mat-spinner diameter="24" style="margin: 12px" matSuffix></mat-spinner>
        }
      </mat-form-field>
    </p>

    <p>
      <mat-form-field appearance="outline">
        <mat-label>Last name</mat-label>
        <input matInput [formField]="personForm.lastName" autocomplete="family-name" />
        @if (pending()) {
          <mat-spinner diameter="24" style="margin: 12px" matSuffix></mat-spinner>
        }
      </mat-form-field>
    </p>

    <p>
      <mat-form-field appearance="outline">
        <mat-label>Organisation</mat-label>
        <input matInput [formField]="personForm.organisation" />
        @if (pending()) {
          <mat-spinner diameter="24" style="margin: 12px" matSuffix></mat-spinner>
        }
      </mat-form-field>
    </p>

    <p>
      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput [formField]="personForm.email" autocomplete="email" />
        <mat-hint
          >The email field is required when the contributor has the role “Point of
          Contact”</mat-hint
        >
        @if (pending()) {
          <mat-spinner diameter="24" style="margin: 12px" matSuffix></mat-spinner>
        }
      </mat-form-field>
    </p>

    <mat-divider />

    <p>
      <mat-form-field appearance="outline">
        <mat-label>Roles</mat-label>
        <mat-select matInput [formField]="personForm.roles" multiple>
          <mat-option value="author">Author</mat-option>
          <mat-option value="editor">Editor</mat-option>
          <mat-option value="pointOfContact">Point of contact</mat-option>
          <mat-option value="principalInvestigator"> Principal investigator </mat-option>
          <mat-option value="processor">Processor</mat-option>
        </mat-select>
        <mat-hint>A contributor must have the role “Author” to be added to the citation.</mat-hint>
      </mat-form-field>
    </p>

    <p>
      <mat-form-field appearance="outline">
        <mat-label>URL</mat-label>
        <mat-hint>URLs must include the protocol (ex: https://example.com)</mat-hint>
        <input matInput [formField]="personForm.url" />
      </mat-form-field>
    </p>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-flat-button
    type="submit"
    form="person-form"
    [disabled]="pending() || personForm().invalid()"
  >
    Save
  </button>
  <button mat-button mat-dialog-close>Cancel</button>
</mat-dialog-actions>
